import React, { createElement } from 'react';
const PIXEL_ID = '1247728440775020';
export function initMetaPixel() {
  if (typeof window === 'undefined') return;
  if ((window as any).fbq) return;
  const n = ((window as any).fbq = function (...args: any[]) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
  }) as any;
  (window as any)._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [] as any[];
  const t = document.createElement('script');
  t.async = true;
  t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const s = document.getElementsByTagName('script')[0];
  s?.parentNode?.insertBefore(t, s);
  (window as any).fbq('init', PIXEL_ID);
  (window as any).fbq('track', 'PageView');
}